/**
 * PD-17142 — the reports that can read the pre-built sales summary
 * (`sales_summary_line_day`, `sales_summary_invoice_day`) for past days
 * instead of adding up every invoice or line on each load. Which of them
 * actually do on a tenant is the `reporting.sales_summary` instance setting;
 * a report not listed here never reads the summary.
 *
 * - `sales-comparison-by-customer` covers both of its views (by customer and
 *   the Region › Team › Rep grouping), which share one invoice scan.
 * - `goals-table` is KPI Details, including its Unassigned row.
 * - `sales-totals` is not a report page: it is the Sales Helper's Sales Total
 *   tool (SalesReportService.getSalesTotals).
 * - A report's drill-downs read the summary with it: Sales by Product's
 *   product group details, Sales by Company's company products, Sales by
 *   Origin's origin products and Sales by Product with Company's details.
 */
export const SALES_SUMMARY_REPORT_IDS = [
	'sales-comparison-by-customer',
	'sales-by-customer-product-group',
	'kpi-overview',
	'goals-table',
	'cumulative-sales-vs-goal',
	'sales-totals',
	'sales-analysis',
	'company-breakdown-sales',
	'regional-sales',
	'sales-by-product',
	'sales-by-company',
	'sales-by-origin',
	'sales-by-product-company',
	'top-performers',
	'item-performance-analysis',
	'top-clients-revenue',
	'customer-analytics',
	'customer-retention',
	'customer-lifetime-value',
	'customer-reorder-summary',
	'market-penetration',
	'territory-analysis',
	'shipping-zone-analysis',
	'product-movement',
	'gross-profit-detail',
] as const;

export type SalesSummaryReportId = (typeof SALES_SUMMARY_REPORT_IDS)[number];

export function isSalesSummaryReportId(
	value: unknown,
): value is SalesSummaryReportId {
	return (
		typeof value === 'string' &&
		(SALES_SUMMARY_REPORT_IDS as ReadonlyArray<string>).includes(value)
	);
}
